export default function UserCard({id, name, lastName, type, userId}) {
    return(
        <div>
            <div className="grid grid-cols-4 gap-2 m-0.5 bg-slate-300">
                {/* <div>
                    {id}
                </div> */}
                <div>
                    <p>{lastName}</p>
                </div>
                <div>
                    <p>{name}</p>
                </div>
                <div>
                    <p>{userId}</p>
                </div>
                <div>
                    <p>{type}</p>
                </div>                
            </div>
        </div>
    )
}